import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import SidebarFit from "../components/SidebarFit";
import { FaBars } from "react-icons/fa";

const FitLayout = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleSidebar = () => setIsOpen(!isOpen);

  return (
    <div className="flex h-screen overflow-hidden">
      <SidebarFit isOpen={isOpen} toggleSidebar={toggleSidebar} />

      {/* Main content */}
      <div className="flex-1 overflow-y-auto relative">
        {/* Header mobile avec votre style original */}
        <header className="block md:hidden bg-darkBlue text-white p-4 sticky top-0 z-50">
          <div className="flex justify-between items-center">
            <h1 className="text-white font-semibold">Veryfit</h1>
            <button 
              onClick={toggleSidebar}
              className="p-1 hover:bg-opacity-80 hover:bg-white hover:bg-opacity-20 rounded transition-colors"
            >
              <FaBars size={24} />
            </button>
          </div>
        </header>

        {/* Contenu principal */}
        <div>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default FitLayout;